import { useBreakpointValue } from "@gluestack-style/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { IdentityInputTypeEnum } from "@repo/core/components/forms/IdentityTypeInput/types";
import { InstallmentSimulateOperationTypeEnum } from "@repo/core/enums/installments";
import { cardFormSchema, cpfFormSchema } from "@repo/core/helpers/zod.schemas";
import { useIdentityTypeInput } from "@repo/core/hooks/useIdentityTypeInput";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import { useForm } from "react-hook-form";
import { z } from "zod";

const simulateInstallmentsValueSchema = z.object({
  installmentsValue: z
    .string({
      required_error: "É necessário informar o valor para a simulação."
    })
    .superRefine((installmentsValue, ctx) => {
      const parsedInstallmentsValue = parseFloat(installmentsValue);
      if (parsedInstallmentsValue <= 1) {
        ctx.addIssue({
          code: "custom",
          message: "O valor deve ser maior que R$ 1,00"
        });
      }
    })
});

export type FormDataType = z.infer<typeof simulateInstallmentsValueSchema>;

export const SimulateInstallmentsValueController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { back, replace, push } = useNavigation();
  const {
    operationType
  }: { operationType: InstallmentSimulateOperationTypeEnum } = useRouteParams();

  const {
    selectedIdentityInputType,
    productInfo,
    handleOnChangeIdentityType,
    handleOnSelectProduct
  } = useIdentityTypeInput({});

  const formSchema =
    selectedIdentityInputType === IdentityInputTypeEnum.CPF
      ? simulateInstallmentsValueSchema.merge(cpfFormSchema)
      : simulateInstallmentsValueSchema.merge(cardFormSchema);

  const {
    control,
    formState: { isValid, isSubmitting },
    watch,
    handleSubmit
  } = useForm<FormDataType>({
    resolver: zodResolver(formSchema),
    defaultValues: { installmentsValue: "0" }
  });

  const installmentsValue = Number(watch("installmentsValue"));

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };

  const handleOnSubmitForm = handleSubmit((formData) => {
    push(ROUTES.simulateInstallments, {
      dblValorOperacao: formData.installmentsValue,
      lngCartao: productInfo?.lngCartao,
      strProduto: productInfo?.strProduto,
      operationType
    });
  });

  return {
    back,
    isMobile,
    handleGoToSales,
    control,
    isValid,
    isSubmitting,
    handleOnSubmitForm,
    installmentsValue,
    handleOnChangeIdentityType,
    selectedIdentityInputType,
    handleOnSelectProduct
  };
};
